var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnSpecial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "#A3A6B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9077 11.9156C28.6433 11.355 28.0975 11 27.5 11C26.9025 11 26.3567 11.355 26.0923 11.9156L21.8439 20.9228L12.3441 22.3671C11.7528 22.457 11.2615 22.8904 11.0769 23.4851C10.8922 24.0797 11.0462 24.7325 11.4741 25.1689L18.3482 32.1799L16.7254 42.0797C16.6244 42.696 16.8665 43.3188 17.35 43.6863C17.8334 44.0538 18.4743 44.1023 19.0032 43.8113L27.5 39.1373L35.9968 43.8113C36.5257 44.1023 37.1666 44.0538 37.65 43.6863C38.1335 43.3188 38.3756 42.696 38.2746 42.0797L36.6518 32.1799L43.5259 25.1689C43.9538 24.7325 44.1078 24.0797 43.9231 23.4851C43.7385 22.8904 43.2472 22.457 42.6558 22.3671L33.1561 20.9228L28.9077 11.9156ZM23.4775 21.5698L27.5 13L31.5225 21.5698C31.8094 22.1811 32.364 22.6048 33.0055 22.7028L42 24.077L35.4915 30.7477C35.0273 31.2235 34.8155 31.909 34.925 32.5808L36.4615 42L28.4166 37.5529C27.8428 37.2357 27.1572 37.2357 26.5834 37.5529L18.5385 42L20.0749 32.5808C20.1845 31.909 19.9727 31.2235 19.5085 30.7477L13 24.077L21.9945 22.7028C22.636 22.6048 23.1906 22.1811 23.4775 21.5698Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSpecial);
export default __webpack_public_path__ + "static/media/icn-special.d6bb0445.svg";
export { ForwardRef as ReactComponent };